import { getBackend } from "../utils/getBackend";
import { getAccessTokenHeader } from "./helper/getAccessTokenHeader";
import { getUser } from "../supabaseClient";
import axios from "axios";
import {
  ImageDerivativeManifest,
  ImageDerivativeSize,
} from "../shared/imageDerivatives";

export interface MissingImage {
  name: string;
  missingSizes: ImageDerivativeSize[];
  reason: "missing" | "outdated" | "refresh";
}

export interface GetMissingImagesResult {
  message: string;
  missingImages: MissingImage[];
  total: number;
}

export interface ProcessSingleImageResult {
  imageName: string;
  manifest?: ImageDerivativeManifest;
  processed: {
    thumbnail: boolean;
    "960px": boolean;
    "2400px": boolean;
    "3600px": boolean;
  };
  errors: string[];
}

export async function getMissingResizedImages(
  refreshHdr = false
): Promise<GetMissingImagesResult> {
  const user = await getUser();

  if (!user) {
    throw new Error("User not authenticated");
  }

  const { data } = await axios.post<GetMissingImagesResult>(
    getBackend() + "/tools/images/get-missing-resized",
    {
      userId: user.id,
      refreshHdr,
    },
    {
      headers: await getAccessTokenHeader(),
      timeout: 1000 * 60 * 5, // 5 minutes timeout
    }
  );

  return data;
}

export async function processSingleResizedImage(
  imageName: string,
  sizesToProcess: ImageDerivativeSize[]
): Promise<ProcessSingleImageResult> {
  const user = await getUser();

  if (!user) {
    throw new Error("User not authenticated");
  }

  const { data } = await axios.post<ProcessSingleImageResult>(
    getBackend() + "/tools/images/process-single-resized",
    {
      userId: user.id,
      imageName,
      sizesToProcess,
    },
    {
      headers: await getAccessTokenHeader(),
      timeout: 1000 * 60 * 5,
    }
  );

  return data;
}
